import { getGisConfiguration } from "../helpers/generalFunctions";
import { types } from "../types/types";

const initialState = getGisConfiguration();

/**
 * Reducer function to set the point in the map
 * @param {object} state information of the Redux Gis
 * @param {*} action -Action to send information to the redux
 */
export const gisReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.gisSetPoint:
            return {
                ...state,
                ...action.payload,
            }
        case types.clearPoint:
            return {
                dataBar: null,
                dataPronostico: [],
            }
        default:
            return state;
    }
}